import "./FoodModal.css";

export default function FoodModal(props) {
 

    const closeModal=()=>{
        try{
            // console.log("here")
            props.setSelectedFoodItem({});
            props.setFoodItemModal(false)
        }catch(error){
            console.log(error)
        }        
    }

  return (
    <div className="food-modal-overlay"  >
      
      <div className="food-item-modal">
        
        <button className="close-btn" onClick={()=>closeModal()}>×</button>
        
        {props?.selectedFoodItem?.imgURL && <img src={props?.selectedFoodItem?.imgURL} alt={props?.selectedFoodItem?.name } className="food-image" />}
        
        <div className="food-details">

          <h2 className="food-name">{props?.selectedFoodItem?.name || "Name"}</h2>
          {(props?.selectedFoodItem?.is_bestseller || props?.selectedFoodItem?.is_chef_recommended )
          &&
            <div className="food-tags">
              {props?.selectedFoodItem?.is_bestseller && <span className="tag bestseller">Bestseller</span>}
              {props?.selectedFoodItem?.is_chef_recommended && <span className="tag recommended">Chef Recommended</span>}
            </div>
          }
          
          <p className="food-price">₹{props?.selectedFoodItem?.price || "Price"}</p>
          <p className="food-desc">{props?.selectedFoodItem?.desc || ""}</p>



        </div>

      </div>


    </div>
  );
}
